<template>
  <div class="bg-ssr-side_bar-background shadow-xl z-10 h-full">
    <div
      class=" text-left flex flex-col h-full"
      :class="{
        'items-end': $i18n.locale == 'en',
        'items-start': $i18n.locale == 'ar',
      }"
    >
      <ul>
        <li
          class="text-center text-white hover:text-ssr-side_bar-link cursor-pointer"
          @click.prevent="this.$emit('collapse')"
        >
          <div
            class="cursor-pointer text-ssr-side_bar-link z-10 rounded-full transform hover:shadow-2xl"
            :class="{
              '-rotate-90': $i18n.locale == 'en',
              'rotate-90': $i18n.locale == 'ar',
            }"
            @click="this.collapsed = !this.collapsed"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-9 w-9 inline-block"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="5"
                d="M5 15l7-7 7 7"
              />
            </svg>
          </div>
        </li>
      </ul>
      <ul
        class="list-reset flex flex-col py-3 text-left h-full overflow-y-auto w-full"
      >
        <li>
          <router-link
            :to="{ name: 'Dashboard' }"
            class="block cursor-pointer py-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div class="inline-block pr-3">
              <svg
                class="mt-1"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 22V12H15V22"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span class="text-xs md:text-base inline-block "
              >{{ $t("sidebar.dashboard") }}
            </span>
          </router-link>
        </li>
        <li
          v-if="
            hasPrivilege('accounts_view_index_accounts') ||
              hasPrivilege('accounts_view_search_accounts') ||
              hasPrivilege('accounts_view_accounts_quota') ||
              hasPrivilege('accounts_view_accounts_passwords') ||
              hasPrivilege('accounts_view_accounts_status') ||
              hasPrivilege('accounts_view_index_online') ||
              hasPrivilege('accounts_view_search_online') ||
              hasPrivilege('accounts_edit_accounts') ||
              hasPrivilege('accounts_delete_accounts') ||
              hasPrivilege('accounts_disable_accounts') ||
              hasPrivilege('accounts_disconnect_accounts') ||
              hasPrivilege('accounts_disconnect_online')
          "
        >
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            @click.prevent="
              drops.accounts = !drops.accounts;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block"
                >{{ $t("sidebar.accounts.accounts") }}
              </span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.accounts }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.accounts" class="text-right">
            <!-- <li
              class="rounded-xl cursor-pointer bg-ssr-side_bar-button text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
            >
              All
            </li> -->
            <router-link
              v-if="
                hasPrivilege('accounts_view_index_accounts') ||
                  hasPrivilege('accounts_view_search_accounts')
              "
              :to="{ name: 'Accounts' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 w-3/4 text-left pl-5 mb-2 mt-1"
              active-class="text-ssr-side_bar-link"
            >
              {{ $t("sidebar.accounts.subscribtions") }}
            </router-link>
            <!-- <router-link
              v-if="hasPrivilege('cards_view_index_cards')"
              :to="{ name: 'AllCards' }"
              class="rounded-xl cursor-pointer bg-ssr-side_bar-button text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.cards.cards") }}
            </router-link> -->
            <router-link
              v-if="hasPrivilege('accounts_view_index_online')"
              :to="{ name: 'OnlineSessions' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.accounts.online_sessions") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('accounts_edit_accounts')"
              :to="{ name: 'AddAccount' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link"
              @click="this.$store.commit('changeKey')"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.accounts.add") }}
            </router-link>
          </div>
        </transition>
        <li
          v-if="
            hasPrivilege('cards_view_index_batches') ||
              hasPrivilege('cards_view_search_batches') ||
              hasPrivilege('cards_view_index_cards') ||
              hasPrivilege('cards_view_search_cards') ||
              hasPrivilege('cards_view_cards_passwords') ||
              hasPrivilege('cards_view_cards_quota') ||
              hasPrivilege('cards_view_cards_status') ||
              hasPrivilege('cards_edit_cards') ||
              hasPrivilege('cards_delete_cards') ||
              hasPrivilege('cards_disable_cards') ||
              hasPrivilege('cards_disconnect_cards')
          "
        >
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
            @click.prevent="
              drops.cards = !drops.cards;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43.75 10.4167H6.25004C3.94885 10.4167 2.08337 12.2822 2.08337 14.5834V39.5834C2.08337 41.8846 3.94885 43.7501 6.25004 43.7501H43.75C46.0512 43.7501 47.9167 41.8846 47.9167 39.5834V14.5834C47.9167 12.2822 46.0512 10.4167 43.75 10.4167Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.08337 22.9167H47.9167"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M43.75 10.4167H6.25004C3.94885 10.4167 2.08337 12.2822 2.08337 14.5834V39.5834C2.08337 41.8846 3.94885 43.7501 6.25004 43.7501H43.75C46.0512 43.7501 47.9167 41.8846 47.9167 39.5834V14.5834C47.9167 12.2822 46.0512 10.4167 43.75 10.4167Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.08337 22.9167H47.9167"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.cards.cards")
              }}</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.cards }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
          <transition name="expandy">
            <div v-if="drops.cards" class="text-right">
              <router-link
                v-if="
                  hasPrivilege('cards_view_index_batches') ||
                    hasPrivilege('cards_view_search_batches') ||
                    hasPrivilege('cards_view_index_batches_reseller')
                "
                :to="{ name: 'Cards' }"
                class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
                active-class="text-ssr-side_bar-link font-bold"
              >
                {{ $t("sidebar.cards.groups") }}
              </router-link>
              <router-link
                v-if="
                  hasPrivilege('cards_view_index_cards') ||
                    hasPrivilege('cards_view_search_cards')
                "
                :to="{ name: 'AllCards' }"
                class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
                active-class="text-ssr-side_bar-link font-bold"
              >
                {{ $t("sidebar.cards.all") }}
              </router-link>
              <router-link
                v-if="hasPrivilege('cards_edit_cards')"
                :to="{ name: 'AddCard' }"
                class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
                active-class="text-ssr-side_bar-link"
                @click="this.$store.commit('changeKey')"
                :class="{ disabled: !settings.license.active }"
              >
                {{ $t("sidebar.cards.generate") }}
              </router-link>
            </div>
          </transition>
        </li>
        <li
          v-if="
            hasPrivilege('profiles_view_index_profiles') ||
              hasPrivilege('profiles_view_search_profiles') ||
              hasPrivilege('profiles_view_profiles_accounts') ||
              hasPrivilege('profiles_view_profiles_nases') ||
              hasPrivilege('profiles_edit_profiles') ||
              hasPrivilege('profiles_delete_profiles') ||
              hasPrivilege('profiles_disable_profiles')
          "
        >
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
            @click.prevent="
              drops.profiles = !drops.profiles;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 47 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.619 19.4232L12.2063 6.49854"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M45.8254 35.8591V15.9367C45.8245 15.0633 45.5939 14.2054 45.1568 13.4493C44.7197 12.6931 44.0915 12.0652 43.3351 11.6285L25.903 1.66727C25.1458 1.23013 24.287 1 23.4127 1C22.5384 1 21.6795 1.23013 20.9224 1.66727L3.4903 11.6285C2.7339 12.0652 2.10564 12.6931 1.66855 13.4493C1.23146 14.2054 1.0009 15.0633 1 15.9367V35.8591C1.0009 36.7325 1.23146 37.5903 1.66855 38.3465C2.10564 39.1026 2.7339 39.7306 3.4903 40.1673L20.9224 50.1285C21.6795 50.5656 22.5384 50.7957 23.4127 50.7957C24.287 50.7957 25.1458 50.5656 25.903 50.1285L43.3351 40.1673C44.0915 39.7306 44.7197 39.1026 45.1568 38.3465C45.5939 37.5903 45.8245 36.7325 45.8254 35.8591Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.67249 13.3469L23.4128 25.9229L45.1531 13.3469"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M23.4127 51V25.8978"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M34.619 19.4232L12.2063 6.49854"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M45.8254 35.8591V15.9367C45.8245 15.0633 45.5939 14.2054 45.1568 13.4493C44.7197 12.6931 44.0915 12.0652 43.3351 11.6285L25.903 1.66727C25.1458 1.23013 24.287 1 23.4127 1C22.5384 1 21.6795 1.23013 20.9224 1.66727L3.4903 11.6285C2.7339 12.0652 2.10564 12.6931 1.66855 13.4493C1.23146 14.2054 1.0009 15.0633 1 15.9367V35.8591C1.0009 36.7325 1.23146 37.5903 1.66855 38.3465C2.10564 39.1026 2.7339 39.7306 3.4903 40.1673L20.9224 50.1285C21.6795 50.5656 22.5384 50.7957 23.4127 50.7957C24.287 50.7957 25.1458 50.5656 25.903 50.1285L43.3351 40.1673C44.0915 39.7306 44.7197 39.1026 45.1568 38.3465C45.5939 37.5903 45.8245 36.7325 45.8254 35.8591Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.67249 13.3469L23.4128 25.9229L45.1531 13.3469"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M23.4127 51V25.8978"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.profiles.profiles")
              }}</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.profiles }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.profiles" class="text-right">
            <router-link
              v-if="
                hasPrivilege('profiles_view_index_profiles') ||
                  hasPrivilege('profiles_view_search_profiles')
              "
              :to="{ name: 'Profiles' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.profiles.all") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('profiles_edit_profiles')"
              :to="{ name: 'AddProfile' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link"
              @click="this.$store.commit('changeKey')"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.profiles.add") }}
            </router-link>
          </div>
        </transition>
        <li
          v-if="
            hasPrivilege('nases_view_index_nases') ||
              hasPrivilege('nases_view_search_nases') ||
              hasPrivilege('nases_view_nases_status') ||
              hasPrivilege('nases_edit_nases') ||
              hasPrivilege('nases_delete_nases') ||
              hasPrivilege('nases_assign_nases')
          "
        >
          <router-link
            :to="{ name: 'Nases' }"
            class="block cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div class="inline-block pr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                />
              </svg>
            </div>
            <span class="text-xs md:text-base inline-block">{{
              $t("sidebar.nas")
            }}</span>
          </router-link>
        </li>
        <li
          v-if="
            (hasPrivilege('support_tickets_view_index_support_tickets') ||
              hasPrivilege('support_tickets_view_search_support_tickets') ||
              hasPrivilege('support_tickets_create_support_tickets') ||
              hasPrivilege('support_tickets_edit_support_tickets') ||
              hasPrivilege('support_tickets_delete_support_tickets')) &&
              settings.features.ssra
          "
        >
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
            @click.prevent="
              drops.support_tickets = !drops.support_tickets;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.support_tickets")
              }}</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.support_tickets }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.support_tickets" class="text-right">
            <router-link
              v-if="
                hasPrivilege('support_tickets_view_index_support_tickets') ||
                  hasPrivilege('support_tickets_view_search_support_tickets')
              "
              :to="{ name: 'SupportTickets' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              @click="this.$store.commit('changeKey')"
            >
              {{ $t("sidebar.profiles.all") }}
            </router-link>
            <router-link
              v-if="
                hasPrivilege('support_tickets_create_support_tickets') ||
                  hasPrivilege('support_tickets_edit_support_tickets') ||
                  hasPrivilege('support_tickets_delete_support_tickets')
              "
              :to="{ name: 'AddSupportTicket' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              @click="this.$store.commit('changeKey')"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.profiles.add") }}
            </router-link>
          </div>
        </transition>
        <li v-if="hasPrivilege('system_ownership') && settings.features.ssra">
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
            @click.prevent="
              drops.notifications = !drops.notifications;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.notifications.notifications")
              }}</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.notifications }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.notifications" class="text-right">
            <router-link
              v-if="hasPrivilege('notifications_view_notifications')"
              :to="{ name: 'Notifications' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.profiles.all") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('notifications_edit_auto_notifications')"
              :to="{ name: 'NotificationsConfig' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
              @click="this.$store.commit('changeKey')"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.notifications.auto") }}
            </router-link>
            <router-link
              v-if="
                hasPrivilege('notifications_wa_notifications') &&
                  settings.features.wa
              "
              :to="{ name: 'NotificationsWhatsapp' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.notifications.wa") }}
            </router-link>
          </div>
        </transition>
        <li
          v-if="
            hasPrivilege('settings_iptv') && settings.features.mikrotik_services
          "
        >
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
            @click.prevent="
              drops.services = !drops.services;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.services.services")
              }}</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.services }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.services" class="text-right">
            <router-link
              v-if="hasPrivilege('system_ownership')"
              :to="{ name: 'Mikrotik' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
              @click="this.$store.commit('changeKey')"
            >
              {{ $t("sidebar.services.mikrotik") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('system_ownership')"
              :to="{ name: 'Bandwidth' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.services.bandwidth") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('settings_iptv') && settings.features.ssra"
              :to="{ name: 'IPTV' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              IPTV
            </router-link>
          </div>
        </transition>

        <li
          v-if="
            (hasPrivilege('admins_view_index_admins') ||
              hasPrivilege('admins_view_search_admins') ||
              hasPrivilege('admins_edit_admins') ||
              hasPrivilege('admins_delete_admins') ||
              hasPrivilege('admins_assign_nases')) &&
              settings.features.admins
          "
        >
          <a
            @click.prevent="
              drops.admins = !drops.admins;
              updateValues();
            "
            class="flex justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M51 50.9999V45.4444C51 42.4975 49.683 39.6714 47.3388 37.5876C44.9946 35.5039 41.8152 34.3333 38.5 34.3333H13.5C10.1848 34.3333 7.00537 35.5039 4.66116 37.5876C2.31696 39.6714 1 42.4975 1 45.4444V50.9999"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M26 23.2222C32.9036 23.2222 38.5 18.2476 38.5 12.1111C38.5 5.97461 32.9036 1 26 1C19.0964 1 13.5 5.97461 13.5 12.1111C13.5 18.2476 19.0964 23.2222 26 23.2222Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M51 50.9999V45.4444C51 42.4975 49.683 39.6714 47.3388 37.5876C44.9946 35.5039 41.8152 34.3333 38.5 34.3333H13.5C10.1848 34.3333 7.00537 35.5039 4.66116 37.5876C2.31696 39.6714 1 42.4975 1 45.4444V50.9999"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M26 23.2222C32.9036 23.2222 38.5 18.2476 38.5 12.1111C38.5 5.97461 32.9036 1 26 1C19.0964 1 13.5 5.97461 13.5 12.1111C13.5 18.2476 19.0964 23.2222 26 23.2222Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.admins")
              }}</span>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.admins }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.admins" class="text-right">
            <router-link
              v-if="hasPrivilege('admins_view_index_admins')"
              :to="{ name: 'Admins' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.profiles.all") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('admins_edit_admins')"
              :to="{ name: 'AddAdmin' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.profiles.add") }}
            </router-link>
          </div>
        </transition>
        <li
          v-if="
            (hasPrivilege('admins_view_index_admins') ||
              hasPrivilege('admins_view_search_admins') ||
              hasPrivilege('admins_edit_admins') ||
              hasPrivilege('admins_delete_admins') ||
              hasPrivilege('admins_assign_nases')) &&
              settings.features.resellers
          "
        >
          <a
            @click.prevent="
              drops.resellers = !drops.resellers;
              updateValues();
            "
            class="flex justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>

              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.resellers")
              }}</span>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.resellers }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.resellers" class="text-right">
            <router-link
              v-if="hasPrivilege('admins_view_index_admins')"
              :to="{ name: 'Resellers' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.profiles.all") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('admins_edit_admins')"
              :to="{ name: 'AddReseller' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.profiles.add") }}
            </router-link>
          </div>
        </transition>
        <li
          v-if="
            hasPrivilege('accounting_view_user_bills') ||
              hasPrivilege('accounting_view_bills') ||
              hasPrivilege('accounting_search_bills') ||
              hasPrivilege('accounting_view_user_transactions') ||
              hasPrivilege('accounting_view_transactions') ||
              hasPrivilege('accounting_search_transactions') ||
              hasPrivilege('accounting_admins_view_bills') ||
              hasPrivilege('accounting_admins_search_bills')
          "
        >
          <a
            @click.prevent="
              drops.accounting = !drops.accounting;
              updateValues();
            "
            class="flex justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="1"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.accounting")
              }}</span>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.accounting }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.accounting" class="text-right">
            <router-link
              v-if="hasPrivilege('accounting_view_bills')"
              :to="{ name: 'Bills' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.bills") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('accounting_admins_view_bills')"
              :to="{ name: 'AdminBills' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.admin_bills") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('accounting_view_transactions')"
              :to="{ name: 'Transactions' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("sidebar.transactions") }}
            </router-link>
          </div>
        </transition>
        <li>
          <router-link
            :to="{ name: 'SessionsFull' }"
            class="block cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div class="inline-block pr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                />
              </svg>
            </div>
            <span class="text-xs md:text-base inline-block">{{
              $t("sidebar.sessions_log")
            }}</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'AdminsLog' }"
            class="block cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div class="inline-block pr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="1"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <span class="text-xs md:text-base inline-block">{{
              $t("sidebar.admins_log")
            }}</span>
          </router-link>
        </li>
        <li v-if="hasPrivilege('reports_print')">
          <router-link
            :to="{ name: 'Reports' }"
            class="block cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link hover:text-white"
            active-class="text-ssr-side_bar-link border-l-4 border-ssr-side_bar-link"
          >
            <div class="inline-block pr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                />
              </svg>
            </div>
            <span class="text-xs md:text-base inline-block">{{
              $t("sidebar.reports")
            }}</span>
          </router-link>
        </li>
        <li
          v-if="
            hasPrivilege('settings_update_settings') ||
              hasPrivilege('settings_view_settings') ||
              hasPrivilege('settings_view_license')
          "
        >
          <a
            class="flex items-center justify-between cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
            @click.prevent="
              drops.settings = !drops.settings;
              updateValues();
            "
          >
            <div>
              <div class="inline-block pr-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="white"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z"
                    stroke="white"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M58.9141 14.0156C58.9141 13.5729 58.7578 13.2344 58.4453 13C58.1328 12.7604 57.5703 12.5104 56.7578 12.25C55.9453 11.9844 55.3021 11.724 54.8281 11.4688C53.5365 10.7708 52.8906 9.83073 52.8906 8.64844C52.8906 8.03385 53.0625 7.48698 53.4062 7.00781C53.7552 6.52344 54.2526 6.14583 54.8984 5.875C55.5495 5.60417 56.2786 5.46875 57.0859 5.46875C57.8984 5.46875 58.6224 5.61719 59.2578 5.91406C59.8932 6.20573 60.3854 6.61979 60.7344 7.15625C61.0885 7.69271 61.2656 8.30208 61.2656 8.98438H58.9219C58.9219 8.46354 58.7578 8.0599 58.4297 7.77344C58.1016 7.48177 57.6406 7.33594 57.0469 7.33594C56.474 7.33594 56.0286 7.45833 55.7109 7.70312C55.3932 7.94271 55.2344 8.26042 55.2344 8.65625C55.2344 9.02604 55.4193 9.33594 55.7891 9.58594C56.1641 9.83594 56.7135 10.0703 57.4375 10.2891C58.7708 10.6901 59.7422 11.1875 60.3516 11.7812C60.9609 12.375 61.2656 13.1146 61.2656 14C61.2656 14.9844 60.8932 15.7578 60.1484 16.3203C59.4036 16.8776 58.401 17.1562 57.1406 17.1562C56.2656 17.1562 55.4688 16.9974 54.75 16.6797C54.0312 16.3568 53.4818 15.9167 53.1016 15.3594C52.7266 14.8021 52.5391 14.1562 52.5391 13.4219H54.8906C54.8906 14.6771 55.6406 15.3047 57.1406 15.3047C57.6979 15.3047 58.1328 15.1927 58.4453 14.9688C58.7578 14.7396 58.9141 14.4219 58.9141 14.0156ZM66.6016 17.1562C65.362 17.1562 64.3516 16.776 63.5703 16.0156C62.7943 15.2552 62.4062 14.2422 62.4062 12.9766V12.7578C62.4062 11.9089 62.5703 11.151 62.8984 10.4844C63.2266 9.8125 63.6901 9.29688 64.2891 8.9375C64.8932 8.57292 65.5807 8.39062 66.3516 8.39062C67.5078 8.39062 68.4167 8.75521 69.0781 9.48438C69.7448 10.2135 70.0781 11.2474 70.0781 12.5859V13.5078H64.6953C64.7682 14.0599 64.987 14.5026 65.3516 14.8359C65.7214 15.1693 66.1875 15.3359 66.75 15.3359C67.6198 15.3359 68.2995 15.0208 68.7891 14.3906L69.8984 15.6328C69.5599 16.112 69.1016 16.487 68.5234 16.7578C67.9453 17.0234 67.3047 17.1562 66.6016 17.1562ZM66.3438 10.2188C65.8958 10.2188 65.5312 10.3698 65.25 10.6719C64.974 10.974 64.7969 11.4062 64.7188 11.9688H67.8594V11.7891C67.849 11.2891 67.7135 10.9036 67.4531 10.6328C67.1927 10.3568 66.8229 10.2188 66.3438 10.2188ZM74.0703 6.46875V8.54688H75.5156V10.2031H74.0703V14.4219C74.0703 14.7344 74.1302 14.9583 74.25 15.0938C74.3698 15.2292 74.599 15.2969 74.9375 15.2969C75.1875 15.2969 75.4089 15.2786 75.6016 15.2422V16.9531C75.1589 17.0885 74.7031 17.1562 74.2344 17.1562C72.651 17.1562 71.8438 16.3568 71.8125 14.7578V10.2031H70.5781V8.54688H71.8125V6.46875H74.0703ZM79.4766 6.46875V8.54688H80.9219V10.2031H79.4766V14.4219C79.4766 14.7344 79.5365 14.9583 79.6562 15.0938C79.776 15.2292 80.0052 15.2969 80.3438 15.2969C80.5938 15.2969 80.8151 15.2786 81.0078 15.2422V16.9531C80.5651 17.0885 80.1094 17.1562 79.6406 17.1562C78.0573 17.1562 77.25 16.3568 77.2188 14.7578V10.2031H75.9844V8.54688H77.2188V6.46875H79.4766ZM84.5625 17H82.2969V8.54688H84.5625V17ZM82.1641 6.35938C82.1641 6.02083 82.276 5.74219 82.5 5.52344C82.7292 5.30469 83.0391 5.19531 83.4297 5.19531C83.8151 5.19531 84.1224 5.30469 84.3516 5.52344C84.5807 5.74219 84.6953 6.02083 84.6953 6.35938C84.6953 6.70312 84.5781 6.98438 84.3438 7.20312C84.1146 7.42188 83.8099 7.53125 83.4297 7.53125C83.0495 7.53125 82.7422 7.42188 82.5078 7.20312C82.2786 6.98438 82.1641 6.70312 82.1641 6.35938ZM88.5078 8.54688L88.5781 9.52344C89.1823 8.76823 89.9922 8.39062 91.0078 8.39062C91.9036 8.39062 92.5703 8.65365 93.0078 9.17969C93.4453 9.70573 93.6693 10.4922 93.6797 11.5391V17H91.4219V11.5938C91.4219 11.1146 91.3177 10.7682 91.1094 10.5547C90.901 10.3359 90.5547 10.2266 90.0703 10.2266C89.4349 10.2266 88.9583 10.4974 88.6406 11.0391V17H86.3828V8.54688H88.5078ZM95.0703 12.7109C95.0703 11.4141 95.3776 10.3698 95.9922 9.57812C96.612 8.78646 97.4453 8.39062 98.4922 8.39062C99.4193 8.39062 100.141 8.70833 100.656 9.34375L100.75 8.54688H102.797V16.7188C102.797 17.4583 102.628 18.1016 102.289 18.6484C101.956 19.1953 101.484 19.612 100.875 19.8984C100.266 20.1849 99.5521 20.3281 98.7344 20.3281C98.1146 20.3281 97.5104 20.2031 96.9219 19.9531C96.3333 19.7083 95.888 19.3906 95.5859 19L96.5859 17.625C97.1484 18.2552 97.8307 18.5703 98.6328 18.5703C99.2318 18.5703 99.6979 18.4089 100.031 18.0859C100.365 17.7682 100.531 17.3151 100.531 16.7266V16.2734C100.01 16.862 99.3255 17.1562 98.4766 17.1562C97.4609 17.1562 96.638 16.7604 96.0078 15.9688C95.3828 15.1719 95.0703 14.1172 95.0703 12.8047V12.7109ZM97.3281 12.875C97.3281 13.6406 97.4818 14.2422 97.7891 14.6797C98.0964 15.112 98.5182 15.3281 99.0547 15.3281C99.7422 15.3281 100.234 15.0703 100.531 14.5547V11C100.229 10.4844 99.7422 10.2266 99.0703 10.2266C98.5286 10.2266 98.1016 10.4479 97.7891 10.8906C97.4818 11.3333 97.3281 11.9948 97.3281 12.875ZM109.117 14.6641C109.117 14.388 108.979 14.1719 108.703 14.0156C108.432 13.8542 107.995 13.7109 107.391 13.5859C105.38 13.1641 104.375 12.3099 104.375 11.0234C104.375 10.2734 104.685 9.64844 105.305 9.14844C105.93 8.64323 106.745 8.39062 107.75 8.39062C108.823 8.39062 109.68 8.64323 110.32 9.14844C110.966 9.65365 111.289 10.3099 111.289 11.1172H109.031C109.031 10.7943 108.927 10.5286 108.719 10.3203C108.51 10.1068 108.185 10 107.742 10C107.362 10 107.068 10.0859 106.859 10.2578C106.651 10.4297 106.547 10.6484 106.547 10.9141C106.547 11.1641 106.664 11.3672 106.898 11.5234C107.138 11.6745 107.539 11.8073 108.102 11.9219C108.664 12.0312 109.138 12.1562 109.523 12.2969C110.716 12.7344 111.312 13.4922 111.312 14.5703C111.312 15.3411 110.982 15.9661 110.32 16.4453C109.659 16.9193 108.805 17.1562 107.758 17.1562C107.049 17.1562 106.419 17.0312 105.867 16.7812C105.32 16.526 104.891 16.1797 104.578 15.7422C104.266 15.2995 104.109 14.8229 104.109 14.3125H106.25C106.271 14.7135 106.419 15.0208 106.695 15.2344C106.971 15.4479 107.341 15.5547 107.805 15.5547C108.237 15.5547 108.562 15.474 108.781 15.3125C109.005 15.1458 109.117 14.9297 109.117 14.6641Z"
                    fill="#262937"
                  />
                </svg>
              </div>
              <span class="text-xs md:text-base inline-block">{{
                $t("sidebar.settings.settings")
              }}</span>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 inline-block transform transition-all duration-500 mx-2"
              :class="{ 'rotate-180': drops.settings }"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </li>
        <transition name="expandy">
          <div v-if="drops.settings" class="text-right">
            <router-link
              v-if="hasPrivilege('settings_update_settings')"
              :to="{ name: 'Settings' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5 mt-1"
              active-class="text-ssr-side_bar-link font-bold"
              @click="this.$store.commit('changeKey')"
            >
              {{ $t("sidebar.settings.system_settings") }}
            </router-link>
            <router-link
              v-if="
                hasPrivilege('settings_update_settings') &&
                  settings.features.backups
              "
              :to="{ name: 'Backup' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.settings.backup") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('settings_update_settings')"
              :to="{ name: 'Restore' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.settings.restore") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('settings_view_license')"
              :to="{ name: 'License' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
            >
              {{ $t("license.license") }}
            </router-link>
            <router-link
              v-if="hasPrivilege('settings_update_settings')"
              :to="{ name: 'Update' }"
              class="rounded-xl cursor-pointer text-white hover:text-ssr-side_bar-link inline-block mx-3 mb-2 w-3/4 text-left pl-5"
              active-class="text-ssr-side_bar-link font-bold"
              :class="{ disabled: !settings.license.active }"
            >
              {{ $t("sidebar.settings.update") }}
            </router-link>
          </div>
        </transition>
        <li class="flex-1">
          <a
            @click.prevent="handleLogout"
            class="block cursor-pointer py-2 mt-2 pl-7 align-middle bg-ssr-side_bar-button text-white no-underline hover:bg-ssr-side_bar-link"
            active-class="bg-blue-300 text-gray-800 font-bold"
          >
            <div class="inline-block pr-3">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                  stroke="white"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 17L21 12L16 7"
                  stroke="white"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21 12H9"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M60.3594 15.1172H65.3359V17H58.0156V5.625H60.3594V15.1172ZM66.1875 12.6953C66.1875 11.8568 66.349 11.1094 66.6719 10.4531C66.9948 9.79688 67.4583 9.28906 68.0625 8.92969C68.6719 8.57031 69.3776 8.39062 70.1797 8.39062C71.3203 8.39062 72.25 8.73958 72.9688 9.4375C73.6927 10.1354 74.0964 11.0833 74.1797 12.2812L74.1953 12.8594C74.1953 14.1562 73.8333 15.1979 73.1094 15.9844C72.3854 16.7656 71.4141 17.1562 70.1953 17.1562C68.9766 17.1562 68.0026 16.7656 67.2734 15.9844C66.5495 15.2031 66.1875 14.1406 66.1875 12.7969V12.6953ZM68.4453 12.8594C68.4453 13.6615 68.5964 14.276 68.8984 14.7031C69.2005 15.125 69.6328 15.3359 70.1953 15.3359C70.7422 15.3359 71.1693 15.1276 71.4766 14.7109C71.7839 14.2891 71.9375 13.6172 71.9375 12.6953C71.9375 11.9089 71.7839 11.2995 71.4766 10.8672C71.1693 10.4349 70.737 10.2188 70.1797 10.2188C69.6276 10.2188 69.2005 10.4349 68.8984 10.8672C68.5964 11.2943 68.4453 11.9583 68.4453 12.8594ZM75.2578 12.7109C75.2578 11.4141 75.5651 10.3698 76.1797 9.57812C76.7995 8.78646 77.6328 8.39062 78.6797 8.39062C79.6068 8.39062 80.3281 8.70833 80.8438 9.34375L80.9375 8.54688H82.9844V16.7188C82.9844 17.4583 82.8151 18.1016 82.4766 18.6484C82.1432 19.1953 81.6719 19.612 81.0625 19.8984C80.4531 20.1849 79.7396 20.3281 78.9219 20.3281C78.3021 20.3281 77.6979 20.2031 77.1094 19.9531C76.5208 19.7083 76.0755 19.3906 75.7734 19L76.7734 17.625C77.3359 18.2552 78.0182 18.5703 78.8203 18.5703C79.4193 18.5703 79.8854 18.4089 80.2188 18.0859C80.5521 17.7682 80.7188 17.3151 80.7188 16.7266V16.2734C80.1979 16.862 79.513 17.1562 78.6641 17.1562C77.6484 17.1562 76.8255 16.7604 76.1953 15.9688C75.5703 15.1719 75.2578 14.1172 75.2578 12.8047V12.7109ZM77.5156 12.875C77.5156 13.6406 77.6693 14.2422 77.9766 14.6797C78.2839 15.112 78.7057 15.3281 79.2422 15.3281C79.9297 15.3281 80.4219 15.0703 80.7188 14.5547V11C80.4167 10.4844 79.9297 10.2266 79.2578 10.2266C78.7161 10.2266 78.2891 10.4479 77.9766 10.8906C77.6693 11.3333 77.5156 11.9948 77.5156 12.875ZM84.375 12.6953C84.375 11.8568 84.5365 11.1094 84.8594 10.4531C85.1823 9.79688 85.6458 9.28906 86.25 8.92969C86.8594 8.57031 87.5651 8.39062 88.3672 8.39062C89.5078 8.39062 90.4375 8.73958 91.1562 9.4375C91.8802 10.1354 92.2839 11.0833 92.3672 12.2812L92.3828 12.8594C92.3828 14.1562 92.0208 15.1979 91.2969 15.9844C90.5729 16.7656 89.6016 17.1562 88.3828 17.1562C87.1641 17.1562 86.1901 16.7656 85.4609 15.9844C84.737 15.2031 84.375 14.1406 84.375 12.7969V12.6953ZM86.6328 12.8594C86.6328 13.6615 86.7839 14.276 87.0859 14.7031C87.388 15.125 87.8203 15.3359 88.3828 15.3359C88.9297 15.3359 89.3568 15.1276 89.6641 14.7109C89.9714 14.2891 90.125 13.6172 90.125 12.6953C90.125 11.9089 89.9714 11.2995 89.6641 10.8672C89.3568 10.4349 88.9245 10.2188 88.3672 10.2188C87.8151 10.2188 87.388 10.4349 87.0859 10.8672C86.7839 11.2943 86.6328 11.9583 86.6328 12.8594ZM98.8359 16.1406C98.2786 16.8177 97.5078 17.1562 96.5234 17.1562C95.6172 17.1562 94.9245 16.8958 94.4453 16.375C93.9714 15.8542 93.7292 15.0911 93.7188 14.0859V8.54688H95.9766V14.0078C95.9766 14.888 96.3776 15.3281 97.1797 15.3281C97.9453 15.3281 98.4714 15.0625 98.7578 14.5312V8.54688H101.023V17H98.8984L98.8359 16.1406ZM105.43 6.46875V8.54688H106.875V10.2031H105.43V14.4219C105.43 14.7344 105.49 14.9583 105.609 15.0938C105.729 15.2292 105.958 15.2969 106.297 15.2969C106.547 15.2969 106.768 15.2786 106.961 15.2422V16.9531C106.518 17.0885 106.062 17.1562 105.594 17.1562C104.01 17.1562 103.203 16.3568 103.172 14.7578V10.2031H101.938V8.54688H103.172V6.46875H105.43Z"
                  fill="white"
                />
              </svg>
            </div>
            <span class="text-xs md:text-base inline-block">{{
              $t("sidebar.logout")
            }}</span>
          </a>
        </li>
        <li>
          <img
            src="@/assets/logo_full2_white.png"
            alt="Logo White"
            class="p-2"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { hasPrivilege } from "../global_constants.js";
export default {
  name: "SideBar",
  data() {
    return {
      drops: {
        accounts: false,
        profiles: false,
        cards: false,
        nases: false,
        admins: false,
        settings: false,
        support_tickets: false,
        resellers: false,
        accounting: false,
      },
    };
  },
  mounted() {
    if (localStorage.getItem("sidebar_drops")) {
      var drps = localStorage.getItem("sidebar_drops");
      drps = JSON.parse(drps);
      this.drops = {
        accounts: drps[0],
        profiles: drps[1],
        cards: drps[2],
        nases: drps[3],
        services: drps[4],
        admins: drps[5],
        settings: drps[6],
        Notifications: drps[7] != null ? drps[7] : false,
        support_tickets: drps[8] != null ? drps[8] : false,
        resellers: drps[9] != null ? drps[9] : false,
        accounting: drps[10] != null ? drps[10] : false,
      };
    }
  },
  computed: {
    ...mapGetters(["user", "settings", "expired"]),
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    updateValues() {
      localStorage.setItem(
        "sidebar_drops",
        JSON.stringify(Object.values(this.drops))
      );
    },
    handleLogout() {
      localStorage.removeItem("token");
      localStorage.removeItem("server_api");
      this.$store.dispatch("user", null);
      this.$store.dispatch("settings", null);
      this.$router.push("/login");
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
